import { render, staticRenderFns } from "./IndustrieIndividuell2.vue?vue&type=template&id=5d744578&"
import script from "./IndustrieIndividuell2.vue?vue&type=script&lang=js&"
export * from "./IndustrieIndividuell2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports